import { render, staticRenderFns } from "./DeviceProfile.vue?vue&type=template&id=1f7af3f8"
import script from "./DeviceProfile.vue?vue&type=script&lang=js"
export * from "./DeviceProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports